/*
 * @Description: 组件输出文件,不打包antd ui组件
 * @Author: zr
 * @Date: 2020-01-02 22:41:48
 * @LastEditors: zr
 * @LastEditTime: 2020-07-07 22:22:54
 */

// 解决Chrome控制台non-passive event listener输出问题
import "default-passive-events";
// 导入样式
import "@/styles/customize-form/dm-form-design.less";

// 导出本地iconfont
import "@/static/icons/iconfont";

// 导入单个组件
import ZrFormDesign from "./ZRFormDesign/index";
import ZrFormPreview from "./ZRFormPreview/index";
import ZrFormBuild from "./ZRFormBuild/index";
import ZrFormItem from "./ZRFormItem/index";
import {
  customComponents,
  basicsList
} from "./ZRFormDesign/config/formItemsConfig";
const components = [ZrFormDesign, ZrFormBuild, ZrFormItem, ZrFormPreview];

const install = function(Vue) {
  // use ant组件
  if (install.installed) return;
  install.installed = true;

  components.map(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

/**
 * @Author: zr
 * @description: 配置组件及添加自定义组件
 * @param {json}
 * @return: Boolean
 */
function setFormDesignConfig(config) {
  try {
    customComponents.title = config.title || "自义定组件";
    customComponents.list = config.list || [];
    // 将自定义组件列表绑到window.$customComponentList上
    window.$customComponentList = config.list || [];
    // uploadFile 配置 start
    // 配置uploadFile默认上传地址
    basicsList[10].options.action =
      config.uploadFile || "http://cdn.zr66.com/uploadFile.txt";

    // 配置uploadFile默认额外参数
    basicsList[10].options.data = JSON.stringify(config.uploadFileData || {});

    // 配置uploadFile默认name
    basicsList[10].options.fileName = config.uploadFileName || "file";
    // 配置uploadFile默认headers
    basicsList[10].options.headers = config.uploadFileHeaders || {};
    // uploadFile 配置 end

    // uploadImage配置 start
    // 配置uploadImage默认上传地址
    basicsList[11].options.action =
      config.uploadImage || "http://cdn.zr66.com/upload-img.txt";
    // 配置uploadImage默认额外参数
    basicsList[11].options.data = JSON.stringify(config.uploadImageData || {});
    // 配置uploadFile默认name
    basicsList[11].options.fileName = config.uploadImageName || "image";
    // 配置uploadFile默认headers
    basicsList[11].options.headers = config.uploadImageHeaders || {};
    // uploadImage配置 end

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}

// 这里可以用es6的解构语法导入组件
export {
  ZrFormDesign,
  ZrFormBuild,
  ZrFormItem,
  ZrFormPreview,
  setFormDesignConfig
};

// 这里默认导入全部组件
export default {
  install,
  setConfig: setFormDesignConfig
};
